import { Component, Inject, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";

import { NgxSpinnerService } from "ngx-spinner";
import Swal from "sweetalert2";
import * as moment from "moment";
import { DatePipe } from "@angular/common";
import Math from "exact-math";
import * as SecureLS from "secure-ls";
import { GlobalService } from "src/app/services/global.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { map, scan } from "rxjs/operators";
import { ExcelServicesService } from "../../services/excel.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { APP_CONFIG, IAppConfig } from "src/app/app.config";
import { Subject } from "rxjs";
import { LoaderService } from "src/app/services/loader.service";
import { StorageService } from "../../services/storage.service";

@Component({
  selector: "app-health-checkup",
  templateUrl: "./health-checkup.component.html",
  styleUrls: ["./health-checkup.component.css"],
})
export class HealthCheckupComponent implements OnInit {
  color = "primary";
  mode = "indeterminate";
  value = 50;
  isLoading: Subject<boolean> = this.loaderservice.isLoading;
  private ls = new SecureLS({ encodingType: "aes" });
  DeviceDetails: any[];
  getdata: any;
  Deviceipdata: any[];
  roleID = this.storageService.getRole();
  userID = this.ls.get("createdBy");

  alphaPattern = "[a-zA-Z .,]*";

  MappingForm: FormGroup;

  showLoadMore = false;
  page: number = 1;
  page_size: number = 10;
  submitted = false;
  getdevice: object;
  getdeviceDetails: any;
  getrasberryDetails: any;
  manualUpdate = true;
  swal: any;
  enable = true;
  total_count: number = 0;
  total_count1: number = 0;
  mapcreate: any;
  mappingList: any[];
  getmapping: any;
  editmapping: any;
  is_active = false;
  create_active: any;
  deletemapping: any;
  editstatus = false;
  mapupdate: any;
  mapstatusupdate: any;
  editid: any;
  department: any;
  dept = [];
  classroom: any;
  class: any;
  audiodevice: any;
  audio: any;
  raspberry: any;
  ras: any;
  camera: any;
  cam: any;
  cam_id: any;
  ras_id: any;
  editbut: boolean;
  camid: any;
  rasid: any;
  isactiveswitch: any;
  page_count = [];
  pageshow = true;
  htmlpageshow: boolean;
  total: number;
  p: number;
  pagedItems: any[];
  writehide = false;
  writeaccess = this.ls.get("write_access");
  tableHeader: any = [];
  cameraip: any;
  serverip: any;
  folder: any;
  rasname: any;
  rastype: any;
  rasip: any;
  deviceList: any;
  angular: any;
  devicetype: any;
  array1: any;
  array2: any;
  newvar: number = 0;

  constructor(
    private storageService: StorageService,
    public datepipe: DatePipe,
    private modalService: NgbModal,
    public router: Router,
    public loaderservice: LoaderService,
    private fb: FormBuilder,
    public globalService: GlobalService,
    private spinner: NgxSpinnerService,
    private ExcelServicesService: ExcelServicesService,
    private http: HttpClient,
    @Inject(APP_CONFIG) private config: IAppConfig
  ) {
    this.spinner.show();

    setTimeout(() => {
      this.spinner.hide();
    }, 5000);
  }

  async ngOnInit() {
    this.MappingForm = this.fb.group({
      id: [""],
      audio_id: ["", [Validators.required]],
      class_room_no: ["", [Validators.required]],
      camera_id: ["", [Validators.required]],
      raspberry_id: ["", [Validators.required]],
    });
    this.page = 1;
    if (this.ls.get("write_access") == 0) {
      this.writehide = true;
    }

    await this.getPage(this.page);
  }

  async ondevicechange(deviceType: string) {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      page: this.page,
      role_id: this.storageService.getRole(),
    };
    switch (deviceType) {
      case "camera":
        this.tableHeader = [
          "S.No",
          "camera Device IP",
          "ClassRoom Details",
          "camera Device Status",
        ];
        filter["device_ip"] = this.cameraip ? this.cameraip : "";
        break;
      case "raspberry":
        this.tableHeader = [
          "S.No",
          "Raspberry IP",
          "ClassRoom Details",
          "Raspberry Device Status",
        ];
        (filter["page_size"] = 1),
          (filter["server_ip"] = this.serverip ? this.serverip : "");
        filter["folder_name"] = this.folder ? this.folder : "";
        break;
      case "fileServer":
        this.tableHeader = ["S.No", "File Server IP", "Folder Name"];
        filter["name"] = this.rasname ? this.rasname : "";
        filter["type"] = this.rastype ? this.rastype : "";
        filter["raspberry_ip"] = this.rasip ? this.rasip : "";
      default:
        break;
    }

    this.getdevice = await this.globalService.get(`${deviceType}/list`, filter);
    this.total_count = this.getdevice["content"].count;

    if (this.getdevice["content"]["rows"].length < this.page_size) {
      this.showLoadMore = true;
    }
    if (this.getdevice["status"] === 200) {
      let response: any[] = this.getdevice["content"]["rows"];
      this.mappingList = response.map((item: any) => {
        return {
          device_ip: item.device_ip || item.raspberry_ip || item.server_ip,
          device_name: item.device_name || item.name || item.folder_name,
          status: item.is_active,
        };
      });

      if (this.pageshow === true) {
        this.page_count = [];
        let page_count = Math.ceil(this.total_count / this.page_size);
        if (page_count > 1) {
          this.htmlpageshow = true;
        } else {
          this.htmlpageshow = false;
        }
      }
    } else {
      this.showLoadMore = true;
    }
    this.spinner.hide();
  }

  exportAsXLSX() {
    this.ExcelServicesService.exportAsExcelFile(this.mappingList, "sample");
  }
  get forms() {
    return this.MappingForm.controls;
  }

  async getclassroom() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.classroom = await this.globalService.get(
      "classroom/list/dropdown",
      filter,
      true
    );

    this.class = this.classroom["content"];
    this.spinner.hide();
  }
  async getAudio() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.audiodevice = await this.globalService.get(
      "audiodevice/list/dropdown",
      filter,
      true
    );

    this.audio = this.audiodevice["content"];
    this.spinner.hide();
  }
  async getraspberry() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.raspberry = await this.globalService.get(
      "raspberry/list/dropdown",
      filter,
      true
    );

    this.ras = this.raspberry["content"];
    this.spinner.hide();
  }
  Filter(camid, rasid) {
    this.camid = camid;
    this.rasid = rasid;
    this.pageshow = true;
    this.page = 1;
    this.getMapping();
  }
  res() {
    this.camid = null;
    this.rasid = null;
    this.pageshow = true;
    this.page = 1;
    this.getMapping();
  }
  async getPage(page: number) {
    this.page = page;
    await this.getMapping();
    const res = await this.serverCall(this.mappingList, page);
    this.total = this.total_count;
    this.p = page;

    this.pagedItems = res;
  }

  async serverCall(sample: any[], page: number) {
    const perPage = 10;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }
  async getcamera() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.camera = await this.globalService.get(
      "camera/list/dropdown",
      filter,
      true
    );

    this.cam = this.camera["content"];
    this.spinner.hide();
  }
  async createMapping(form: FormGroup) {
    this.submitted = true;

    if (this.MappingForm.invalid) {
      return;
    }

    this.spinner.show();
    const inputData = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      audio_device_id: form.value.audio_id,
      class_room_id: form.value.class_room_no,
      camera_id: form.value.camera_id,
      raspberry_id: form.value.raspberry_id,
    };
    this.mapcreate = await this.globalService.create(
      "mapping/create",
      inputData
    );

    if (this.mapcreate["status"] === 200) {
      Swal.fire("Success!", this.mapcreate["message"], "success");
      this.pageshow = true;
      this.getMapping();
      this.reset();
    }

    this.spinner.hide();
  }

  async getMapping() {
    if (this.page === 1) {
      this.mappingList = [];
    }

    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      page: this.page,
      camera_id: this.camid ? this.camid : "",
      raspberry_id: this.rasid ? this.rasid : "",
      page_size: this.page_size,
    };
  }

  editMapping(id, camera_id, raspberry_id) {
    this.spinner.show();
    Swal.fire({
      title: "Edit ?",
      text: "Are you sure you want to edit this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        this.editbut = true;

        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id,
          camera_id: camera_id,
          raspberry_id: raspberry_id,
        };

        this.editmapping = await this.globalService.get("mapping/get", filter);
        let comp_details = this.editmapping["content"];

        if (this.editmapping["status"] === 200) {
          this.MappingForm.controls["id"].setValue(comp_details.id);
          this.MappingForm.controls["audio_id"].setValue(
            comp_details.audio_device_id
          );
          this.MappingForm.controls["class_room_no"].setValue(
            comp_details.class_room_id
          );
          this.MappingForm.controls["camera_id"].setValue(
            comp_details.camera_id
          );
          this.MappingForm.controls["raspberry_id"].setValue(
            comp_details.raspberry_id
          );
          this.editid = comp_details.id;
          this.cam_id = comp_details.camera_id;
          this.ras_id = comp_details.raspberry_id;
        }
      }
    });
    this.spinner.hide();
  }
  reset() {
    this.submitted = false;
    this.MappingForm.reset();
    this.editstatus = false;
  }

  loadMore(index) {
    this.pageshow = true;
    this.page = index;
    this.getMapping();
  }
  previous() {
    this.pageshow = true;
    this.page = this.page - 1;
    this.getMapping();
  }
  next() {
    this.pageshow = true;
    this.page = this.page + 1;
    this.getMapping();
  }

  async updateMapping(form: FormGroup) {
    this.submitted = true;

    if (this.MappingForm.invalid) {
      return;
    }
    this.spinner.show();
    const inputData = {
      id: form.value.id,
      vendor_id: this.ls.get("vendor_id"),
      user_id: this.ls.get("createdBy"),
      audio_device_id: form.value.audio_id,
      class_room_id: form.value.class_room_no,
      camera_id: form.value.camera_id,
      raspberry_id: form.value.raspberry_id,
    };

    this.mapupdate = await this.globalService.update(
      "mapping/update",
      inputData
    );

    if (this.mapupdate["status"] === 200) {
      Swal.fire("Success!", this.mapupdate["message"], "success");
      this.editbut = false;
      this.pageshow = true;
      this.getMapping();
      this.reset();
    }

    this.spinner.hide();
  }
  // Modal
  openScrollableContent(longContent) {
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
    }
  }
  async deleteMapping(id, camera_id, raspberry_id, classroom_id) {
    this.spinner.show();
    Swal.fire({
      title: "Delete ?",
      text: "Are you sure you want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id,
          camera_id: camera_id,
          raspberry_id: raspberry_id,
          classroom_id: classroom_id,
        };
        this.deletemapping = await this.globalService.delete(
          "mapping/delete",
          filter
        );
        if (this.deletemapping["status"] === 200) {
          this.mappingList = [];
          Swal.fire("Success!", this.deletemapping["message"], "success");
          this.pageshow = true;
          this.getMapping();
        }
      }
    });
    this.spinner.hide();
  }

  formReset() {
    this.MappingForm.reset();
    this.editbut = false;
  }

  async GetDeviceData(deviceType: any) {
    this.loaderservice.show();
    this.DeviceDetails = [];
    this.total_count = 0;
    let active = 1;
    let filter;
    if (deviceType === "fileServer") {
      filter = {
        user_id: this.ls.get("createdBy"),
        vendor_id: this.ls.get("vendor_id"),
        page: this.page,
        page_size: 100,
        role_id: this.storageService.getRole(),
      };
    } else {
      filter = {
        user_id: this.ls.get("createdBy"),
        vendor_id: this.ls.get("vendor_id"),
        page: this.page,
        page_size: 100,
        role_id: this.storageService.getRole(),
        is_active: active,
      };
    }

    if (deviceType === "camera") {
      this.devicetype = "Camera";
      this.tableHeader = [
        "S.No",
        "Device Name",
        "Classroom No.",
        "Classroom Name",
        "camera Device IP",
        "Hardware status",
        "Hardware status Updated At",
      ];
    } else if (deviceType === "raspberry") {
      this.devicetype = "Raspberry";
      this.tableHeader = [
        "S.No",
        "Device Name",
        "Classroom No.",
        "Classroom Name",
        "Raspberry IP",
        "Hardware status",
        "Hardware status Updated At",
      ];
    } else {
      this.devicetype = "file_server";
      this.tableHeader = [
        "S.No",
        "Folder Name",
        "File Server IP",
        "Available Memory",
        "Used Memory",
        "Free Memory",
        "Hardware status",
        "Hardware status Updated At",
      ];
      this.newvar = 1;
    }

    const inputData = {
      device_type: this.devicetype,
    };
    this.globalService
      .healthcheckup("api/iot/update-device-network-status", inputData)
      .subscribe(async (resp) => {
        this.getdeviceDetails = resp;
        this.array2 = this.getdeviceDetails["content"];
        this.total_count1 = this.array2.length;

        if (deviceType == "camera" || deviceType == "raspberry") {
          this.getdata = await this.globalService.get(
            `${deviceType}/list`,
            filter
          );
          this.mappingList = this.getdata["content"]["rows"];
          this.total_count = this.getdata["content"].count;
          this.DeviceDetails = this.mappingList;
        } else {
          this.getdata = await this.globalService.get(
            `${deviceType}/list`,
            filter
          );
          this.mappingList = this.getdata["content"]["rows"];
          this.total_count = this.getdata["content"].count;
          this.DeviceDetails = this.mappingList.map((subject) => {
            let otherSubject = this.array2.find(
              (element) => element.file_server_ip === subject.server_ip
            );
            return { ...subject, ...otherSubject };
          });
          
        }

        this.loaderservice.hide();
      });
    (error) => {
      this.loaderservice.hide();
      Swal.fire("Alert!", "Device is not Updated", "error");
    };
  }

  downloadReport() {
    this.loaderservice.show();
    let dataToExport: any = [];
    let reportData: any;
    reportData = this.DeviceDetails;
    if (reportData.length <= 0) {
      Swal.fire("Error!", "No Record Found!", "error");
      this.loaderservice.hide();
      return false;
    } else {
      if (this.newvar == 1) {
        for (let ii = 0; ii < reportData.length; ii++) {
          dataToExport.push({
            "S.No": ii + 1,
            "Folder Name":
              reportData[ii].device_name ||
              reportData[ii].name ||
              reportData[ii].folder_name,
            "File Server IP":
              reportData[ii].device_ip ||
              reportData[ii].raspberry_ip ||
              reportData[ii].server_ip,
            "Available Memory": reportData[ii].available_storage ? reportData[ii].available_storage : "0"  + " GB",
            "Used Memory": reportData[ii].userd_storage ? reportData[ii].userd_storage :"0" + " GB",
            "Free Memory": reportData[ii].free_storage ? reportData[ii].free_storage : "0" + " GB",
            "Hardware Status":
              reportData[ii].hardware_status === 1
                ? "Connected"
                : "DisConnected",
            "Hardware status Updated At": this.datepipe.transform(
              reportData[ii].hardware_status_updated_at,
              "dd/MM/yyyy h:mm:ss a"
            ),
          });
        }
      } else {
        for (let ii = 0; ii < reportData.length; ii++) {
          dataToExport.push({
            "Sr No": ii + 1,
            DeviceName:
              reportData[ii].device_name ||
              reportData[ii].name ||
              reportData[ii].folder_name,
            "Device ip":
              reportData[ii].device_ip ||
              reportData[ii].raspberry_ip ||
              reportData[ii].server_ip,
            "Hardware Status":
              this.array2[reportData[ii].device_ip] ||
              this.array2[reportData[ii].raspberry_ip] ||
              this.array2[reportData[ii].server_ip] === 1
                ? "Connected"
                : "Disconnected",
            "Hardware status Updated At": this.datepipe.transform(
              reportData[ii].hardware_status_updated_at,
              "dd/MM/yyyy h:mm:ss a"
            ),
          });
        }
      }

      this.ExcelServicesService.exportAsExcelFile(
        dataToExport,
        "Device_HealthCheckup_Report"
      );
      this.newvar = 0;
      Swal.fire("Success!", "Report Downloaded Successfully!", "success");
    }
    this.loaderservice.hide();
  }
  paginationCount(value) {
    this.page = 1;
    if (value >= 5) {
      this.page_size = value;
    }
    this.getMapping();
  }
}
